import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { CacheService } from 'projects/shared/src/lib/services/cache/cache.service';
import { AppLocalCacheService } from 'projects/shared/src/lib/services/cache/local-cache.service';

import { ApiService as AS } from 'ets-fe-ng-sdk';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'projects/shared/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService extends AS {
  public override cacheS = inject(CacheService);
  public override lCacheS = inject(AppLocalCacheService);
  constructor() {
    super();
    if (environment.apiBaseUrl) this.baseURL = environment.apiBaseUrl;
  }

  getWithProgress = <T = any>(
    route: string,
    parameters?: { [field: string]: string | number | boolean },
  ): Observable<T> => {
    // this.logRoutes('get', route, parameters);
    const query = route + this.getRequestParse(parameters);
    return new Observable<T>((res) => {
      this.http
        .request(
          new HttpRequest('GET', query, {
            reportProgress: true,
            headers: new HttpHeaders()
              .set('Content-Type', 'application/json')
              .set('Access-Control-Allow-Headers', 'Content-Length')
              .set('Access-Control-Expose-Headers', 'Content-Length'),
          }),
        )
        .subscribe({
          next: (r) => {
            console.log((<any>r)?.['total']);
            res.next(r as any);
            // res.complete();
          },
          error: (err) => {
            res.error(err);
          },
        });
    });
  };
  // postFile<T = any>(route: string, body: FormData, extras?: any) {
  //   // return this.post<T>(route, body, {
  //   //   options: {
  //   //     responseType: 'json',
  //   //     ...extras?.options,
  //   //     headers: this.concatenateHeaders(
  //   //       new HttpHeaders({
  //   //         enctype: 'multipart/form-data',
  //   //       }),
  //   //       extras?.options?.headers
  //   //     ),
  //   //   },
  //   // });

  //   return this.http
  //     .post(encodeURI(route), body, {
  //       // responseType: 'json',
  //       ...extras?.options,
  //       // headers: this.concatenateHeaders(
  //       //   new HttpHeaders({
  //       //     enctype: 'multipart/form-data',
  //       //   }),
  //       //   extras?.options?.headers
  //       // ),
  //     })
  //     .pipe(catchError(this.handleRequestError)) as Observable<any>;
  // }
}

@Injectable({
  providedIn: 'root',
})
export class APIWorkflowService extends AS {
  public override cacheS = inject(CacheService);
  public override lCacheS = inject(AppLocalCacheService);
  constructor() {
    super();
    if (environment.apiWorkflowBaseUrl) this.baseURL = environment.apiWorkflowBaseUrl;
  }
}

@Injectable({
  providedIn: 'root',
})
export class APIGatewayService extends AS {
  public override cacheS = inject(CacheService);
  public override lCacheS = inject(AppLocalCacheService);
  constructor() {
    super();
    if (environment.apiGatewayBaseUrl) this.baseURL = environment.apiGatewayBaseUrl;
  }
}

@Injectable({
  providedIn: 'root',
})
export class APIMessagingService extends AS {
  public override cacheS = inject(CacheService);
  public override lCacheS = inject(AppLocalCacheService);
  constructor() {
    super();
    if (environment.apiMessagingBaseUrl) this.baseURL = environment.apiMessagingBaseUrl;
  }
}

@Injectable({
  providedIn: 'root',
})
export class APIPolicyService extends AS {
  public override cacheS = inject(CacheService);
  public override lCacheS = inject(AppLocalCacheService);
  constructor() {
    super();
    if (environment.apiPolicyBaseUrl) this.baseURL = environment.apiPolicyBaseUrl;
  }
}

@Injectable({
  providedIn: 'root',
})
export class APIUserService extends AS {
  public override cacheS = inject(CacheService);
  public override lCacheS = inject(AppLocalCacheService);
  constructor() {
    super();
    if (environment.apiUserServiceBaseUrl) this.baseURL = environment.apiUserServiceBaseUrl;
  }
}

@Injectable({
  providedIn: 'root',
})
export class APINasService extends AS {
  public override cacheS = inject(CacheService);
  public override lCacheS = inject(AppLocalCacheService);

  constructor() {
    super();
    this.baseURL = environment.apiNasBaseUrl;
  }
}
